// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VWAp","input":"styles_input__1jsWW"};